'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _dec, _dec2, _class2, _class3, _temp3;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _schoollevels = require('redux/modules/schoollevels');

var _reactRouter = require('react-router');

var _strings = require('utils/strings');

var _reactLadda = require('react-ladda');

var _reactLadda2 = _interopRequireDefault(_reactLadda);

var _reactDraggableList = require('react-draggable-list');

var _reactDraggableList2 = _interopRequireDefault(_reactDraggableList);

var _components = require('components');

var _copy = require('redux/modules/copy');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChapterListItem = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ChapterListItem, _Component);

  function ChapterListItem() {
    (0, _classCallCheck3.default)(this, ChapterListItem);
    return (0, _possibleConstructorReturn3.default)(this, (ChapterListItem.__proto__ || (0, _getPrototypeOf2.default)(ChapterListItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(ChapterListItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          dragHandle = _props.dragHandle,
          item = _props.item,
          itemSelected = _props.itemSelected;

      var dragged = itemSelected > 0.75;
      var styles = require('./SchoolLevel.scss');

      return _react2.default.createElement(
        'div',
        { className: styles.chapterListItem + (dragged ? ' dragged' : '') },
        dragHandle(_react2.default.createElement(
          'div',
          null,
          item.label
        ))
      );
    }
  }]);
  return ChapterListItem;
}(_react.Component), _class.propTypes = {
  dragHandle: _react.PropTypes.func.isRequired,
  item: _react.PropTypes.object.isRequired,
  itemSelected: _react.PropTypes.number.isRequired
}, _temp);
var SchoolLevel = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: false,
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;

    return dispatch((0, _schoollevels.load)());
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    schoolLevels: state.schoolLevels.data,
    loading: state.schoolLevels.loading,
    saving: state.schoolLevels.saving,
    copying: state.copy.copying,
    copyError: state.copy.error
  };
}), _dec(_class2 = _dec2(_class2 = (_temp3 = _class3 = function (_Component2) {
  (0, _inherits3.default)(SchoolLevel, _Component2);

  function SchoolLevel() {
    var _ref2;

    var _temp2, _this2, _ret;

    (0, _classCallCheck3.default)(this, SchoolLevel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp2 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = SchoolLevel.__proto__ || (0, _getPrototypeOf2.default)(SchoolLevel)).call.apply(_ref2, [this].concat(args))), _this2), _this2.state = {
      schoolLevel: undefined,
      name: undefined,
      shortName: undefined,
      slug: undefined,
      published: undefined,
      accessible: undefined,
      fieldErrors: [],
      chapterFieldErrors: [],
      chapter: {},
      editing: false,
      creatingChapter: false,
      saving: false,
      sorting: false,
      sortedChapters: undefined,
      copyChapterModalVisible: false,
      copyChapterModalObject: {}
    }, _this2.componentWillMount = function () {
      var _this2$props = _this2.props,
          schoolLevels = _this2$props.schoolLevels,
          routeParams = _this2$props.routeParams,
          saving = _this2$props.saving;

      var schoolLevelId = routeParams.schoolLevelId;
      var schoolLevel = schoolLevels.find(function (level) {
        return level._id === schoolLevelId;
      });
      _this2.setState({
        saving: saving,
        schoolLevel: schoolLevel,
        name: schoolLevel.name,
        slug: schoolLevel.slug,
        shortName: schoolLevel.shortName,
        published: schoolLevel.published,
        accessible: schoolLevel.accessible,
        seo: schoolLevel.seo
      });
    }, _this2.componentWillReceiveProps = function (newProps) {
      var schoolLevels = newProps.schoolLevels,
          routeParams = newProps.routeParams,
          saving = newProps.saving;

      var prevSaving = _this2.state.saving;

      if (saving === false && prevSaving === true) {
        _this2.setState({
          editing: false,
          sorting: false
        });
      }

      if (_this2.props.copying && !newProps.copying && !newProps.copyError) {
        _this2.setState({
          copyChapterModalVisible: false
        });
      }

      var schoolLevelId = routeParams.schoolLevelId;
      var schoolLevel = schoolLevels.find(function (level) {
        return level._id === schoolLevelId;
      });
      _this2.setState({
        saving: saving,
        schoolLevel: schoolLevel,
        name: schoolLevel.name,
        slug: schoolLevel.slug,
        shortName: schoolLevel.shortName,
        published: schoolLevel.published,
        accessible: schoolLevel.accessible,
        seo: schoolLevel.seo
      });
    }, _this2.onListChange = function (newList) {
      _this2.setState({
        sortedChapters: newList
      });
    }, _this2.handleFieldChange = function (param, event) {
      var _this2$setState;

      var fieldErrors = _this2.state.fieldErrors;
      fieldErrors[param] = null;

      if (param === 'name') {
        _this2.setState({
          slug: (0, _strings.slugify)(event.target.value)
        });
      }

      _this2.setState((_this2$setState = {}, (0, _defineProperty3.default)(_this2$setState, param, event.target.value), (0, _defineProperty3.default)(_this2$setState, 'fieldErrors', fieldErrors), _this2$setState));
    }, _this2.handleBooleanFieldChange = function (param) {
      _this2.setState((0, _defineProperty3.default)({}, param, !_this2.state[param]));
    }, _this2.handleChapterFieldChange = function (param, event) {
      var _this2$state = _this2.state,
          chapterFieldErrors = _this2$state.chapterFieldErrors,
          chapter = _this2$state.chapter;

      chapterFieldErrors[param] = null;

      chapter[param] = event.target.value;

      if (param === 'title') {
        chapter.slug = (0, _strings.slugify)(chapter.title);
      }

      _this2.setState({
        chapter: chapter,
        chapterFieldErrors: chapterFieldErrors
      });
    }, _this2.handleSEOFieldChange = function (param, event) {
      var seo = _this2.state.seo;

      seo[param] = event.target.value;
      _this2.setState({ seo: seo });
    }, _this2.handleRemoveSchoolLevel = function () {
      _this2.props.dispatch((0, _schoollevels.remove)(_this2.state.schoolLevel));
    }, _this2.handleStartChapterCreation = function () {
      _this2.setState({
        creatingChapter: true
      });
    }, _this2.handleStopChapterCreation = function () {
      _this2.setState({
        creatingChapter: false
      });
    }, _this2.handleShowCopyChapterModal = function (chapterId) {
      _this2.setState({
        copyChapterModalVisible: true,
        copyChapterModalObject: {
          chapter: _this2.state.schoolLevel.chapters.find(function (chapter) {
            return chapter._id._id === chapterId;
          }),
          schoolLevelIndex: 0
        }
      });
    }, _this2.handleCopyChapterModalFieldChange = function (param, event) {
      var copyChapterModalObject = _this2.state.copyChapterModalObject;


      copyChapterModalObject[param] = event.target.value;

      _this2.setState({
        copyChapterModalObject: copyChapterModalObject
      });
    }, _this2.handleHideCopyChapterModal = function () {
      _this2.setState({
        copyChapterModalVisible: false
      });
    }, _this2.handleSaveCopyChapterModal = function () {
      var copyChapterModalObject = _this2.state.copyChapterModalObject;


      _this2.props.dispatch((0, _copy.copyChapter)({
        chapterId: copyChapterModalObject.chapter._id._id,
        destSchoolLevelId: _this2.props.schoolLevels[copyChapterModalObject.schoolLevelIndex]._id
      }));
    }, _this2.handleCreateChapter = function (event) {
      event.preventDefault();
      var _this2$state2 = _this2.state,
          chapter = _this2$state2.chapter,
          schoolLevel = _this2$state2.schoolLevel;


      _this2.props.dispatch((0, _schoollevels.createChapter)({
        title: chapter.title,
        slug: chapter.slug,
        schoolLevel: schoolLevel._id
      }));

      _this2.setState({
        chapter: {},
        chapterFieldErrors: [],
        creatingChapter: false
      });
    }, _this2.handleStartSorting = function () {
      _this2.setState({
        sorting: true
      });
    }, _this2.handleSaveSorting = function () {
      var _this2$state3 = _this2.state,
          sortedChapters = _this2$state3.sortedChapters,
          schoolLevel = _this2$state3.schoolLevel;

      schoolLevel.chapters = [];

      for (var index = 0; index < sortedChapters.length; index++) {
        var chapter = sortedChapters[index];

        schoolLevel.chapters.push({
          _id: { _id: chapter.id },
          rank: index + 1
        });
      }

      _this2.props.dispatch((0, _schoollevels.save)(schoolLevel));
    }, _this2.handleEndSorting = function () {
      _this2.setState({
        sorting: false
      });
    }, _this2.handleSaveSchoolLevel = function (event) {
      event.preventDefault();

      var _this2$state4 = _this2.state,
          schoolLevel = _this2$state4.schoolLevel,
          name = _this2$state4.name,
          shortName = _this2$state4.shortName,
          slug = _this2$state4.slug,
          published = _this2$state4.published,
          accessible = _this2$state4.accessible,
          seo = _this2$state4.seo;


      _this2.setState({ fieldErrors: {} });
      var fieldErrors = {};
      if (!name) {
        fieldErrors.name = 'Champs requis';
      }
      if (!shortName) {
        fieldErrors.shortName = 'Champs requis';
      }
      if (!slug) {
        fieldErrors.slug = 'Champs requis';
      }

      _this2.setState({ fieldErrors: fieldErrors });

      if ((0, _keys2.default)(fieldErrors).length === 0) {
        schoolLevel.name = name;
        schoolLevel.shortName = shortName;
        schoolLevel.slug = slug;
        schoolLevel.published = published;
        schoolLevel.accessible = accessible;
        schoolLevel.seo = seo;
        _this2.props.dispatch((0, _schoollevels.save)(schoolLevel));
      }
    }, _this2.handleStartEditing = function () {
      _this2.setState({
        editing: true
      });
    }, _this2.handleStopEditing = function () {
      _this2.setState({
        editing: false
      });
    }, _temp2), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(SchoolLevel, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          editing = _state.editing,
          schoolLevel = _state.schoolLevel,
          name = _state.name,
          shortName = _state.shortName,
          published = _state.published,
          accessible = _state.accessible,
          slug = _state.slug,
          seo = _state.seo,
          creatingChapter = _state.creatingChapter,
          chapterFieldErrors = _state.chapterFieldErrors,
          chapter = _state.chapter,
          saving = _state.saving,
          sorting = _state.sorting,
          copyChapterModalObject = _state.copyChapterModalObject,
          copyChapterModalVisible = _state.copyChapterModalVisible;

      var orderedChapters = schoolLevel ? schoolLevel.chapters.sort(function (first, second) {
        return first.rank - second.rank;
      }) : [];
      var references = orderedChapters.map(function (chapterReference) {
        return {
          id: chapterReference._id._id,
          label: chapterReference._id.title,
          index: chapterReference.rank
        };
      });

      var styles = require('./SchoolLevel.scss');
      var fieldErrors = this.state.fieldErrors;
      // require the logo image both from client and server

      if (schoolLevel) {
        return _react2.default.createElement(
          'div',
          { className: styles.schoolLevels },
          _react2.default.createElement(
            'section',
            { className: styles.box },
            _react2.default.createElement(
              'h1',
              { className: styles.boxTitle },
              schoolLevel.name
            ),
            _react2.default.createElement('div', { className: styles.boxBar })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.content },
            _react2.default.createElement(
              'section',
              { className: styles.box },
              _react2.default.createElement(
                'div',
                null,
                !editing ? _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: styles.line },
                    _react2.default.createElement(
                      'div',
                      { className: styles.propertyName },
                      'Nom'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: styles.propertyValue },
                      schoolLevel.name
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.line },
                    _react2.default.createElement(
                      'div',
                      { className: styles.propertyName },
                      'Abbr\xE9viation'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: styles.propertyValue },
                      schoolLevel.shortName
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.line },
                    _react2.default.createElement(
                      'div',
                      { className: styles.propertyName },
                      'URL'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: styles.propertyValue },
                      schoolLevel.slug
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.line },
                    _react2.default.createElement(
                      'div',
                      { className: styles.propertyName },
                      'Publi\xE9'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: styles.propertyValue },
                      schoolLevel.published ? 'Oui' : 'Non'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.line },
                    _react2.default.createElement(
                      'div',
                      { className: styles.propertyName },
                      'Ouvert'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: styles.propertyValue },
                      schoolLevel.accessible ? 'Oui' : 'Non'
                    )
                  ),
                  _react2.default.createElement(
                    'button',
                    { onClick: this.handleStartEditing },
                    'Modifier'
                  )
                ) : _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'button',
                    { onClick: this.handleRemoveSchoolLevel },
                    'Supprimer le niveau'
                  ),
                  _react2.default.createElement(
                    'form',
                    { className: styles.form },
                    _react2.default.createElement(
                      'div',
                      { className: styles.line },
                      _react2.default.createElement(
                        'label',
                        { className: styles.inputFieldLabel, htmlFor: 'name' },
                        'Nom'
                      ),
                      _react2.default.createElement('input', { className: styles.inputFieldInput,
                        type: 'text',
                        name: 'name',
                        value: name,
                        onChange: this.handleFieldChange.bind(null, 'name') }),
                      _react2.default.createElement(
                        'span',
                        { className: styles.inputFieldError },
                        fieldErrors.name
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: styles.line },
                      _react2.default.createElement(
                        'label',
                        { className: styles.inputFieldLabel, htmlFor: 'name' },
                        'Abbr\xE9viation'
                      ),
                      _react2.default.createElement('input', { className: styles.inputFieldInput,
                        type: 'text',
                        name: 'shortName',
                        value: shortName,
                        onChange: this.handleFieldChange.bind(null, 'shortName') }),
                      _react2.default.createElement(
                        'span',
                        { className: styles.inputFieldError },
                        fieldErrors.shortName
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: styles.line },
                      _react2.default.createElement(
                        'label',
                        { className: styles.inputFieldLabel, htmlFor: 'name' },
                        'URL'
                      ),
                      _react2.default.createElement('input', { className: styles.inputFieldInput,
                        type: 'text',
                        name: 'slug',
                        value: slug,
                        disabled: 'disabled',
                        onChange: this.handleFieldChange.bind(null, 'slug') }),
                      _react2.default.createElement(
                        'span',
                        { className: styles.inputFieldError },
                        fieldErrors.slug
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: styles.line },
                      _react2.default.createElement(
                        'label',
                        { className: styles.inputFieldLabel, htmlFor: 'published' },
                        'Publi\xE9'
                      ),
                      _react2.default.createElement('input', { type: 'checkbox',
                        name: 'published',
                        checked: published,
                        onChange: this.handleBooleanFieldChange.bind(null, 'published') })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: styles.line },
                      _react2.default.createElement(
                        'label',
                        { className: styles.inputFieldLabel, htmlFor: 'accessible' },
                        'Ouvert'
                      ),
                      _react2.default.createElement('input', { type: 'checkbox',
                        name: 'accessible',
                        checked: accessible,
                        onChange: this.handleBooleanFieldChange.bind(null, 'accessible') })
                    ),
                    _react2.default.createElement('hr', null),
                    _react2.default.createElement(
                      'h3',
                      null,
                      'SEO'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: styles.line },
                      _react2.default.createElement(
                        'label',
                        { className: styles.inputFieldLabel, htmlFor: 'seoTitle' },
                        '[meta] Title'
                      ),
                      _react2.default.createElement('input', { className: styles.inputFieldInput,
                        type: 'text',
                        name: 'seoTitle',
                        value: seo.title,
                        onChange: this.handleSEOFieldChange.bind(null, 'title') }),
                      _react2.default.createElement(
                        'span',
                        { className: styles.inputFieldError },
                        fieldErrors.slug
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: styles.line },
                      _react2.default.createElement(
                        'label',
                        { className: styles.inputFieldLabel, htmlFor: 'seoH1' },
                        'Titre H1'
                      ),
                      _react2.default.createElement('input', { className: styles.inputFieldInput,
                        type: 'text',
                        name: 'seoH1',
                        value: seo.h1,
                        onChange: this.handleSEOFieldChange.bind(null, 'h1') }),
                      _react2.default.createElement(
                        'span',
                        { className: styles.inputFieldError },
                        fieldErrors.slug
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: styles.line },
                      _react2.default.createElement(
                        'label',
                        { className: styles.inputFieldLabel, htmlFor: 'seoFooter' },
                        'Texte de pied de page'
                      ),
                      _react2.default.createElement('textarea', {
                        className: styles.inputFieldInput,
                        name: 'seoFooter',
                        onChange: this.handleSEOFieldChange.bind(null, 'footer'),
                        defaultValue: seo.footer
                      }),
                      _react2.default.createElement(
                        'span',
                        { className: styles.inputFieldError },
                        fieldErrors.slug
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: styles.line },
                      _react2.default.createElement('input', { className: styles.documentSaveButton,
                        type: 'cancel',
                        value: 'Annuler',
                        onClick: this.handleStopEditing }),
                      _react2.default.createElement(
                        _reactLadda2.default,
                        { className: styles.documentSaveButton,
                          'data-style': 'slide-down',
                          loading: saving, onClick: this.handleSaveSchoolLevel },
                        'Enregistrer'
                      )
                    )
                  )
                )
              )
            ),
            !editing ? _react2.default.createElement(
              'section',
              { className: styles.box },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h2',
                  { className: styles.boxSubtitle },
                  'Chapitres'
                ),
                orderedChapters.length > 1 ? _react2.default.createElement(
                  'button',
                  { onClick: this.handleStartSorting },
                  'Trier les chapitres'
                ) : null,
                sorting ? _react2.default.createElement(
                  _components.Modal,
                  { onCancel: this.handleEndSorting, onSave: this.handleSaveSorting },
                  _react2.default.createElement(_reactDraggableList2.default, {
                    itemKey: 'id',
                    template: ChapterListItem,
                    list: references,
                    onMoveEnd: function onMoveEnd(newList, movedItem, oldIndex, newIndex) {
                      return _this3.onListChange(newList, movedItem, oldIndex, newIndex);
                    },
                    container: function container() {
                      return document.body;
                    }
                  })
                ) : null,
                _react2.default.createElement(
                  'table',
                  { className: styles.listing },
                  _react2.default.createElement(
                    'thead',
                    null,
                    _react2.default.createElement(
                      'tr',
                      null,
                      _react2.default.createElement(
                        'th',
                        null,
                        '#'
                      ),
                      _react2.default.createElement(
                        'th',
                        null,
                        'Titre'
                      ),
                      _react2.default.createElement(
                        'th',
                        null,
                        'URL'
                      ),
                      _react2.default.createElement(
                        'th',
                        null,
                        'Sections'
                      ),
                      _react2.default.createElement(
                        'th',
                        null,
                        'Matrice'
                      ),
                      _react2.default.createElement(
                        'th',
                        null,
                        'Publi\xE9'
                      ),
                      _react2.default.createElement(
                        'th',
                        null,
                        '\xA0'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'tbody',
                    null,
                    orderedChapters.length > 0 ? orderedChapters.map(function (chapterReference, index) {
                      return _react2.default.createElement(
                        'tr',
                        { key: index },
                        _react2.default.createElement(
                          'td',
                          null,
                          chapterReference.rank
                        ),
                        _react2.default.createElement(
                          'td',
                          null,
                          _react2.default.createElement(
                            _reactRouter.Link,
                            { activeClassName: styles.activeItem, className: styles.chapterLink,
                              to: '/schoollevels/' + schoolLevel._id + '/chapters/' + chapterReference._id._id },
                            chapterReference._id.title
                          )
                        ),
                        _react2.default.createElement(
                          'td',
                          null,
                          chapterReference._id.slug
                        ),
                        _react2.default.createElement(
                          'td',
                          null,
                          chapterReference._id.documentsSections.length
                        ),
                        _react2.default.createElement(
                          'td',
                          null,
                          chapterReference._id.requirements && chapterReference._id.requirements.length > 0 ? 'OK' : 'À compléter'
                        ),
                        _react2.default.createElement(
                          'td',
                          null,
                          chapterReference._id.published ? 'Oui' : 'Non'
                        ),
                        _react2.default.createElement(
                          'td',
                          null,
                          _react2.default.createElement('i', { className: styles.iconButton + ' fa fa-copy',
                            'aria-hidden': 'true',
                            onClick: _this3.handleShowCopyChapterModal.bind(null, chapterReference._id._id) })
                        )
                      );
                    }) : _react2.default.createElement(
                      'tr',
                      null,
                      _react2.default.createElement(
                        'td',
                        { colSpan: '6' },
                        'Aucun chapitre.'
                      )
                    )
                  )
                ),
                creatingChapter ? _react2.default.createElement(
                  'form',
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: styles.line },
                    _react2.default.createElement(
                      'label',
                      { htmlFor: 'name' },
                      'Nom'
                    ),
                    _react2.default.createElement('input', { type: 'text',
                      name: 'name',
                      value: chapter.name,
                      onChange: this.handleChapterFieldChange.bind(null, 'title'),
                      onEnterPress: this.handleSaveSchoolLevel }),
                    _react2.default.createElement(
                      'span',
                      null,
                      chapterFieldErrors.name
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.line },
                    _react2.default.createElement(
                      'label',
                      { htmlFor: 'name' },
                      'URL'
                    ),
                    _react2.default.createElement('input', { type: 'text',
                      name: 'slug',
                      disabled: 'disabled',
                      value: chapter.slug,
                      onChange: this.handleChapterFieldChange.bind(null, 'slug'),
                      onEnterPress: this.handleSaveSchoolLevel }),
                    _react2.default.createElement(
                      'span',
                      null,
                      chapterFieldErrors.slug
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.line },
                    _react2.default.createElement('input', { type: 'submit',
                      value: 'Cr\xE9er',
                      onClick: this.handleCreateChapter }),
                    _react2.default.createElement('input', { type: 'button',
                      value: 'Annuler',
                      onClick: this.handleStopChapterCreation })
                  )
                ) : _react2.default.createElement(
                  'button',
                  { onClick: this.handleStartChapterCreation },
                  'Ajouter un chapitre'
                )
              ),
              _react2.default.createElement('br', null)
            ) : null
          ),
          copyChapterModalVisible && _react2.default.createElement(
            _components.Modal,
            { onCancel: this.handleHideCopyChapterModal, onSave: this.handleSaveCopyChapterModal, saving: this.props.copying },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'p',
                null,
                'Copie du chapitre : ',
                _react2.default.createElement(
                  'b',
                  null,
                  copyChapterModalObject.chapter._id.title
                )
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'b',
                  null,
                  'Destination'
                ),
                ' : '
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'form',
                null,
                _react2.default.createElement(
                  'div',
                  { className: styles.line },
                  _react2.default.createElement(
                    'label',
                    { className: styles.inputFieldLabel, htmlFor: 'iconClass' },
                    'Niveau'
                  ),
                  _react2.default.createElement(
                    'select',
                    { className: styles.inputFieldInput,
                      name: 'schoolLevelIndex',
                      onChange: this.handleCopyChapterModalFieldChange.bind(null, 'schoolLevelIndex') },
                    this.props.schoolLevels.map(function (level, index) {
                      return _react2.default.createElement(
                        'option',
                        { value: index },
                        level.name
                      );
                    })
                  ),
                  _react2.default.createElement(
                    'span',
                    null,
                    fieldErrors.schoolLevel
                  )
                )
              )
            )
          )
        );
      }

      return null;
    }
  }]);
  return SchoolLevel;
}(_react.Component), _class3.propTypes = {
  schoolLevels: _react.PropTypes.array.isRequired,
  dispatch: _react.PropTypes.func.isRequired,
  routeParams: _react.PropTypes.object.isRequired,
  history: _react.PropTypes.object.isRequired,
  loading: _react.PropTypes.bool.isRequired,
  saving: _react.PropTypes.bool.isRequired,
  copying: _react.PropTypes.bool.isRequired,
  copyError: _react.PropTypes.object
}, _temp3)) || _class2) || _class2);
exports.default = SchoolLevel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/SchoolLevel/SchoolLevel.js
// module id = 1191
// module chunks = 0